import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { TimePeriod } from "@src/cloud-connect/blueprint/dashboards/entities/time-period";
import { Frequency } from "@src/cloud-connect/blueprint/dashboards/entities/tile";
import { DashboardTileNode } from "@src/cloud-connect/blueprint/dashboards/entities/dashboard-tile-node";

// Timeseries Call - four
export const fetchNodesTimeseriesAggregatedDataForDashboard = (
  groupId: string,
  frequency: Frequency,
  time_period: TimePeriod,
  nodes: DashboardTileNode[],
  signal?: AbortSignal,
) => {
  const result = fetch(
    `${appUrl()}/api/get-timeseries-aggregated-data-for-dashboard`,
    {
      method: "POST",
      headers: buildAuthenticationHeaders(),
      body: JSON.stringify({
        ...buildAuthenticationBody(),
        group_id: groupId,
        frequency,
        time_period: time_period,
        nodes: nodes,
      }),
      signal,
    },
  )
    .then(async (res) => {
      if (res.status === 200) {
        return res.json();
      } else if (res.status === 404) {
        return null;
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (signal?.aborted) return;
      else if (err instanceof TokensExpiredError) {
        console.log("error: ", err);
      } else if (err instanceof DOMException) {
        return;
      } else {
        console.log("generic error", err);
      }
    });

  return result;
};
